var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dataTabIcon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.8 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.8 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dataTabIcon",
    d: "M6.8,64.7v3.609c0,1.606,3.574,2.9,8,2.9s8-1.289,8-2.9V64.7c-1.907,1.289-5.111,1.8-8,1.8S8.707,65.989,6.8,64.7Z",
    transform: "translate(-6.8 -54.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dataTabIcon",
    d: "M14.8,33.524c-2.889,0-6.093-.516-8-1.824v3.629c0,1.586,3.574,2.875,8,2.875s8-1.289,8-2.9V31.7C20.893,33.009,17.689,33.524,14.8,33.524Z",
    transform: "translate(-6.8 -26.773)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dataTabIcon",
    cx: 8,
    cy: 2.895,
    rx: 8,
    ry: 2.895,
    transform: "translate(0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/Data.52eb535a.svg";
export { ForwardRef as ReactComponent };